<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-user-plus"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'contador.solicitar.titulo' | translate }}</h1>
    <p class="header-subtitle">{{ 'contador.solicitar.descricao' | translate }}</p>
  </div>
</div>

<div class="page-body">
  <div class="form-card">
    <div class="card-header">
      <div class="card-header-icon">
        <i class="pi pi-user-plus"></i>
      </div>
      <span class="card-header-title">{{ 'contador.solicitar.titulo' | translate }}</span>
    </div>

    <div class="card-content">
      <!-- Miolo compartilhado (page: mantem o botao "Ir para a Area") -->
      <app-solicitar-contador-panel></app-solicitar-contador-panel>
    </div>
  </div>
</div>
